import React from 'react';
import { HomeIcon, LibraryIcon, GlobeIcon } from 'lucide-react';
interface NavigationProps {
  currentPage: string;
  onNavigate: (page: string) => void;
}
export function Navigation({
  currentPage,
  onNavigate
}: NavigationProps) {
  const navItems = [{
    id: 'home',
    label: 'Home',
    icon: HomeIcon
  }, {
    id: 'library',
    label: 'Library',
    icon: LibraryIcon
  }, {
    id: 'globe',
    label: 'Globe',
    icon: GlobeIcon
  }];
  return <div className="fixed bottom-0 left-0 right-0 h-16 bg-zinc-900 border-t border-zinc-800 flex items-center justify-around" data-id="element-153">
      {navItems.map(item => {
      const Icon = item.icon;
      const isActive = currentPage === item.id;
      return <button key={item.id} className={`flex flex-col items-center justify-center w-20 h-full ${isActive ? 'text-green-500' : 'text-zinc-400'}`} onClick={() => onNavigate(item.id)} data-id="element-154">
            <Icon size={20} data-id="element-155" />
            <span className="text-xs mt-1" data-id="element-156">{item.label}</span>
          </button>;
    })}
    </div>;
}